import React, { useEffect, useState, useEffect as ReactUseEffect } from "react";
import { bulkUpsertEpisodes, getPlan } from "../api/postPlansApi";
import { Box, Paper, Stack, TextField, IconButton, Button, Alert } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

export default function StepEpisodes({ planId, registerSave }) {
  const [rows, setRows] = useState([{ code: "E01", title: "Puntata 1", deadline_date: "" }]);
  const [status, setStatus] = useState({ saving: false, error: null, saved: false });

  useEffect(() => {
    if (planId) {
      getPlan(planId).then(p => {
        if (p.episodes && p.episodes.length) setRows(p.episodes);
      }).catch(e => setStatus(s => ({...s, error: e.message})));
    }
  }, [planId]);

  const addRow = () => setRows([...rows, { code: `E${String(rows.length+1).padStart(2,"0")}`, title: "", deadline_date: "" }]);
  const delRow = (i) => setRows(rows.filter((_, idx) => idx !== i));
  const upd = (i, key, val) => setRows(rows.map((r, idx) => idx === i ? { ...r, [key]: val } : r));

 const save = async () => {
  setStatus({ saving: true, error: null, saved: false });
  try {
      const payload = rows
        .map(r => ({
          code: (r.code || "").trim(),
          title: (r.title || "").trim() || (r.code || "").trim(),
          deadline_date: r.deadline_date && String(r.deadline_date).trim() !== "" ? r.deadline_date : null,
          rx_date:       r.rx_date       && String(r.rx_date).trim()       !== "" ? r.rx_date       : null,
          tx_date:       r.tx_date       && String(r.tx_date).trim()       !== "" ? r.tx_date       : null,
          notes: r.notes || null
        }))
        .filter(r => r.code);
      await bulkUpsertEpisodes(planId, payload);
    setStatus({ saving: false, error: null, saved: true });
    return true;
  } catch (e) {
    setStatus({ saving: false, error: e.message, saved: false });
    alert(e.message || "Errore salvataggio puntate");
    return false;
  }
};

  // ► collega il footer del wizard
  ReactUseEffect(() => {
    if (!registerSave) return;
    registerSave(async () => await save());
  }, [registerSave, rows]);

  return (
    <Box>
      {status.error && <Alert severity="error">{status.error}</Alert>}
      <Paper variant="outlined">
        <Box p={2}>
          {rows.map((r, i) => (
            <Stack key={i} direction="row" spacing={1} alignItems="center" mb={1}>
              <TextField size="small" label="ID" value={r.code} onChange={e=>upd(i,"code",e.target.value)} sx={{ width: 120 }}/>
              <TextField size="small" label="Titolo" value={r.title} onChange={e=>upd(i,"title",e.target.value)} sx={{ flex: 1 }}/>
              <TextField size="small" type="date" label="Deadline" InputLabelProps={{ shrink: true }}
                value={r.deadline_date || ""} onChange={e=>upd(i,"deadline_date",(e.target.value || "").trim())}/>
              <TextField size="small" type="date" label="RX" InputLabelProps={{ shrink: true }}
                value={r.rx_date || ""} onChange={e=>upd(i,"rx_date", e.target.value)} sx={{ minWidth: 170 }}/>
              <TextField size="small" type="date" label="TX" InputLabelProps={{ shrink: true }}
                value={r.tx_date || ""} onChange={e=>upd(i,"tx_date", e.target.value)} sx={{ minWidth: 170 }}/>
              <IconButton onClick={() => delRow(i)}><DeleteIcon /></IconButton>
            </Stack>
          ))}
          <Stack direction="row" spacing={1}>
            <Button startIcon={<AddIcon />} onClick={addRow}>Aggiungi</Button>
            <Button variant="contained" onClick={save} disabled={status.saving}>Salva</Button>
          </Stack>
        </Box>
      </Paper>
    </Box>
  );
}
